import $ from 'jquery';
import 'jquery-validation';
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import workIndex from './routes/workIndex';
import workPage from './routes/workPageCommon';
import careers from './routes/careers';
import careersDetails from './routes/careersDetails';
import internships from './routes/internships';
import capabilitiesPage from './routes/capabilities';
import partnerPage from './routes/partner';
import wealthManagementPage from './routes/wealthManagement';
import researchPage from './routes/researchPage';

import * as Sentry from '@sentry/browser';
import {BrowserTracing} from '@sentry/tracing';

Sentry.init({
  dsn: 'https://a0a920fb72ed4c1f9d081af29f6eb67d@o617019.ingest.sentry.io/6523203',
  environment: window.sentryEnvironment,

  // Alternatively, use `process.env.npm_package_version` for a dynamic release version
  // if your build tool supports it.
  // release: "my-project-name@2.3.12",
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
  ]
});

import '../css/main.scss';

const routes = new Router({
  common, // All pages
  home,
  pageTemplateWork: workIndex, // "/work" landing page
  workPage, // the actual case studies in /work/*
  careers,
  careersDetails,
  internships,
  pageTemplateCapabilitiesDesign: capabilitiesPage,
  pageTemplateCapabilitiesStrategy: capabilitiesPage,
  pageTemplateCapabilitiesTechnology: capabilitiesPage,
  pageTemplatePartnerAdobe: partnerPage,
  pageTemplatePartnerSitecore: partnerPage,
  pageTemplatePartnerSitefinity: partnerPage,
  pageTemplateFutureWealthManagement: wealthManagementPage,
  singleResearch: researchPage,
});

// Load Events
$(document).ready(() => routes.loadEvents());
